import React from 'react';
import "./Promenu.css";


import i1 from './images/a.jpeg';



function Promain(){
        return(
            
<div >

   
<div>
<a href="/python-variables" style={{ textDecoration: 'none' }}>
<div className="white">
<div >
    
    <h1>Python</h1>
  <p>Python Tutorials For Beginners</p>


  <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
        fontSize:"1.2rem"
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>

     
        {"\n"}

<span className="qwerty-2">print</span>
    <span className="qwerty-3">(</span>
      <span className="qwerty-5">"</span> 
      <span className="qwerty-6">Learn Python Coding Free</span> 
      <span className="qwerty-5">"</span> 
    <span className="qwerty-3">)</span>
 
    {"\n"}
        {"\n"}

    
       
        </code>
      </pre>        
    </div>   </div>
    <div className="film-btn">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="gooey">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="5"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    type="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                    result="highContrastGraphic"
                  />
                  <feComposite
                    in="SourceGraphic"
                    in2="highContrastGraphic"
                    operator="atop"
                  />
                </filter>
              </defs>
            </svg>

            <button id="gooey-button">
              Python Tutorial
              <span class="bubbles">
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
              </span>
            </button>
          </div>
 
</div>
</a></div>




<div className="red">
<a href="/java-variables" style={{ textDecoration: 'none' }}>

<div >
    
    <h1>Java </h1>
  <p>Java Tutorials For Beginners</p>


  <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
        fontSize:"1.2rem" 
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
      
     
        {"\n"}

        <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"This is Java First program or Hello World "</span>
      <span className="qwerty-1">);</span>

    {"\n"}
        {"\n"}

    
       
        </code>
      </pre>        
    </div>   </div>
    <div className="film-btn">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="gooey">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="5"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    type="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                    result="highContrastGraphic"
                  />
                  <feComposite
                    in="SourceGraphic"
                    in2="highContrastGraphic"
                    operator="atop"
                  />
                </filter>
              </defs>
            </svg>

            <button id="gooey-button">
              Java Tutorial
              <span class="bubbles">
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
              </span>
            </button>
          </div>
 


</a></div>



<div className="white">
<a href="/csharp-first-program" style={{ textDecoration: 'none' }}>

<div >
    
    <h1>Csharp</h1>
  <p>C# Tutorials For Beginners</p>


  <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
        fontSize:"1.2rem"
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
     
        {"\n"}

        <span className="qwerty-10">Console</span>
            <span className="qwerty-4">.WriteLine </span>
            <span className="qwerty-2">(</span>
              <span className="qwerty-3">"</span>
              <span className="qwerty">hello </span>
              <span className="qwerty-2">world </span>
              <span className="qwerty-6">program </span>
              <span className="qwerty-2">in </span>
              <span className="qwerty-5">CSharp</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-5">;</span>

    {"\n"}
        {"\n"}

    
       
        </code>
      </pre>        
    </div>   </div>
    <div className="film-btn">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="gooey">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="5"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    type="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                    result="highContrastGraphic"
                  />
                  <feComposite
                    in="SourceGraphic"
                    in2="highContrastGraphic"
                    operator="atop"
                  />
                </filter>
              </defs>
            </svg>

            <button id="gooey-button">
            Csharp Tutorials
              <span class="bubbles">
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
              </span>
            </button>
          </div>
 

</a></div>



<div>
<a href="/javascript-variables" style={{ textDecoration: 'none' }}>
<div className="red">
<div >
    
    <h1>Javascript</h1>
  <p>Js Tutorials For Beginners</p>


  <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
        fontSize:"1.2rem" 
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
     
     
        <span className="qwerty-10">document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Hello World in Js"</span>
      <span className="qwerty-1">);</span>
   
        {"\n"}        {"\n"}

    
       
        </code>
      </pre>        
    </div>   </div>
    <div className="film-btn">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="gooey">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="5"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    type="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                    result="highContrastGraphic"
                  />
                  <feComposite
                    in="SourceGraphic"
                    in2="highContrastGraphic"
                    operator="atop"
                  />
                </filter>
              </defs>
            </svg>

            <button id="gooey-button">
            Javascript Tutorial
              <span class="bubbles">
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
              </span>
            </button>
          </div>
 
</div>

</a></div>


<div>
<a href="/php-variables" style={{ textDecoration: 'none' }}>

<div className="white">
<div >
    
    <h1>PHP</h1>
  <p>PHP Tutorials For Beginners</p>


  <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
        fontSize:"1.2rem"
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
   
     
        {"\n"}

        <span className="qwerty-10">echo </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty">Learn </span>
            <span className="qwerty-7">Free PHP Tutorial</span>
            <span className="qwerty-4">"; </span>

    {"\n"}
        {"\n"}

    
       
        </code>
      </pre>        
    </div>   </div>
    <div className="film-btn">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="gooey">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="5"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    type="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                    result="highContrastGraphic"
                  />
                  <feComposite
                    in="SourceGraphic"
                    in2="highContrastGraphic"
                    operator="atop"
                  />
                </filter>
              </defs>
            </svg>

            <button id="gooey-button">
            PHP Tutorials
              <span class="bubbles">
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
              </span>
            </button>
          </div>
 
</div>
</a></div>


<div>
<a href="/c-variable" style={{ textDecoration: 'none' }}>
<div className="red">
<div >
    
    <h1>C Tutorials</h1>
  <p>C Tutorials For Beginners</p>


  <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
        fontSize:"1.2rem" 
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
      
     
        {"\n"}

        <span className="qwerty-7">   printf</span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">Learn C Tutorials</span>
            <span className="qwerty-3">");</span>

    {"\n"}
        {"\n"}

    
       
        </code>
      </pre>        
    </div>   </div>
    <div className="film-btn">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="gooey">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="5"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    type="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                    result="highContrastGraphic"
                  />
                  <feComposite
                    in="SourceGraphic"
                    in2="highContrastGraphic"
                    operator="atop"
                  />
                </filter>
              </defs>
            </svg>

            <button id="gooey-button">
            C Tutorials
              <span class="bubbles">
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
              </span>
            </button>
          </div>
 
</div>

</a></div>


<div>
<a href="/cpp-variable" style={{ textDecoration: 'none' }}>
<div className="white">
<div >
    
    <h1>C++ Tutorials</h1>
  <p>C++ Tutorials For Beginners</p>


  <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
        fontSize:"1.2rem"
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
       
     
        {"\n"}

        <span className="qwerty-6"> cout </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Learn C++</span>
            <span className="qwerty-11"> Free Tutorials </span>
         
            <span className="qwerty-3">";</span>
  
    {"\n"}
        {"\n"}

    
       
        </code>
      </pre>        
    </div>   </div>
    <div className="film-btn">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="gooey">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="5"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    type="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                    result="highContrastGraphic"
                  />
                  <feComposite
                    in="SourceGraphic"
                    in2="highContrastGraphic"
                    operator="atop"
                  />
                </filter>
              </defs>
            </svg>

            <button id="gooey-button">
            C++ Tutorials
              <span class="bubbles">
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>



                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
              </span>
            </button>
          </div>
     
</div>
</a></div>

<div className="diffbox ">
<h1>Difference B/w Codes</h1>
</div>





<a href="/java-vs-csharp-basic" style={{ textDecoration: 'none' }}>
<div className="white">
<div >
    
    <h1>Diff b/w Java and C# Tutorial</h1>
 


  <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
        fontSize:"1.2rem"
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
     
      

        <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"This is Java First program or Hello World "</span>
      <span className="qwerty-1">);</span> {"\n"}

    {"\n"}


    <span className="qwerty-10">Console</span>
            <span className="qwerty-4">.WriteLine </span>
            <span className="qwerty-2">(</span>
              <span className="qwerty-3">"</span>
              <span className="qwerty">hello </span>
              <span className="qwerty-2">world </span>
              <span className="qwerty-6">program </span>
              <span className="qwerty-2">in </span>
              <span className="qwerty-5">CSharp</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-5">;</span>
        {"\n"}
        {"\n"}
    
       
        </code>
      </pre>        
    </div>   </div>
    <div className="film-btn">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="gooey">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="5"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    type="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                    result="highContrastGraphic"
                  />
                  <feComposite
                    in="SourceGraphic"
                    in2="highContrastGraphic"
                    operator="atop"
                  />
                </filter>
              </defs>
            </svg>

            <button id="gooey-button">
            Java V/S C#
              <span class="bubbles">
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
              </span>
            </button>
          </div>
     
</div>
</a>
<a href="/java-vs-python-basic" style={{ textDecoration: 'none' }}>
<div className="red">
<div >
    
    <h1>Diff b/w Java and Python Tutorial</h1>
 
  <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
        fontSize:"1.2rem" 
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
     



        <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"This is Java First program or Hello World "</span>
      <span className="qwerty-1">);</span>   
       {"\n"}    {"\n"}
      <span className="qwerty-2">print</span>
    <span className="qwerty-3">(</span>
      <span className="qwerty-5">"</span> 
      <span className="qwerty-6">Learn Python Coding Free</span> 
      <span className="qwerty-5">"</span> 
    <span className="qwerty-3">)</span>

    {"\n"}
        {"\n"}

    
       
        </code>
      </pre>        
    </div>   </div>
    <div className="film-btn">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="gooey">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="5"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    type="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                    result="highContrastGraphic"
                  />
                  <feComposite
                    in="SourceGraphic"
                    in2="highContrastGraphic"
                    operator="atop"
                  />
                </filter>
              </defs>
            </svg>

            <button id="gooey-button">
            Java V/S Python
              <span class="bubbles">
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>

                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
                <span class="bubble"></span>
              </span>
            </button>
          </div>
 
</div>

</a>

<div className="iframe-container">
<iframe className="youtubedesign"  src="https://www.youtube.com/embed/hBDdQ4D8bg4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>



<img  className="design" src={i1} alt ="learn coding for by CodeExampler website free www.codeexampler.com"/ >

</div>
   );
    }

export  default Promain;